import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Panel } from 'rsuite';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../containers/inventory/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import ResultHeader from './ResultHeader';
import SearchForm from '../../../../components/inventory/reports/ItemsAndPackagesSkusForm';
import ItemsAndPackagesSkusList from '../../../../components/inventory/reports/ItemsAndPackagesSkusList';
import {
  getIsFetched,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/items-and-packages-skus';

export default () => {
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  return (
    <PageLayout>
      <PageHeader title="Items/Packages SKUs">
        <SearchForm />
      </PageHeader>
      <Content>
        {isFetching && <ContentLoader />}
        {isFetched && (
          <Panel bodyFill bordered header={<ResultHeader />}>
            <ItemsAndPackagesSkusList />
          </Panel>
        )}
      </Content>
    </PageLayout>
  );
};
